import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const MapsMarkerCheck = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color6.hex,
    description,
    dmId = 'dm-maps-marker-check',
    pointerEvents = 'none',
    secondColor = theme.palette.color5.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.mapsMarkerCheck.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        d="m11.9948 2a7.6186 7.6186 0 0 0 -7.7726 7.4107c0 5.21 5.2446 10.6509 6.7971 12.201a1.4326 1.4326 0 0 0 1.9614 0c1.5944-1.55 6.7971-7.0006 6.7971-12.201a7.6192 7.6192 0 0 0 -7.783-7.4107z"
        fill={color}
      />
      <path
        d="m10.75 13.9043a.7467.7467 0 0 1 -.53-.22l-2-2a.75.75 0 1 1 1.06-1.0603l1.47 1.47 3.97-3.97a.75.75 0 1 1 1.06 1.0606l-4.5 4.5a.7467.7467 0 0 1 -.53.2197z"
        fill={secondColor}
      />
    </IconSvg>
  );
};

export default memo(MapsMarkerCheck);
